<div class="profile-modal-chrome">
  <h2 class="profile-modal-title" id="profile-modal-heading">Tu cuenta</h2>
  <button
    mat-icon-button
    type="button"
    class="profile-modal-close"
    mat-dialog-close
    aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div
  mat-dialog-content
  class="profile-modal-body"
  aria-labelledby="profile-modal-heading">

  @if (firebaseUser$ | async; as fb) {
    <div class="profile-card profile-card--embedded">
      <header class="profile-header">
        <div class="profile-avatar" aria-hidden="true">
          <span>{{ getInitials(fb) }}</span>
        </div>
        <div class="profile-identity">
          <h3 class="profile-name">{{ getFullName(fb) }}</h3>
          <div class="profile-meta">
            @if (fb.AppUser?.email) {
              <span class="profile-meta-item">
                <mat-icon class="profile-meta-icon">mail</mat-icon>
                {{ fb.AppUser?.email }}
              </span>
            }
            @if (fb.AppUser?.documentId || fb.AppUser?.Person?.DocumentId_Person; as docId) {
              <span class="profile-meta-item">
                <mat-icon class="profile-meta-icon">badge</mat-icon>
                {{ docId }}
              </span>
            }
          </div>
          @if (fb.AppUser?.isSuperAdmin) {
            <div class="profile-role-list">
              <span class="profile-role-chip">SuperAdmin</span>
            </div>
          }
        </div>
      </header>

      <section class="profile-section">
        <h4 class="profile-section-title">
          <mat-icon class="profile-section-icon">tune</mat-icon>
          Preferencias
        </h4>
        <div class="profile-preference">
          <div class="profile-preference-info">
            <mat-icon class="profile-preference-icon">
              {{ fb.AppUser?.darkMode ? "dark_mode" : "light_mode" }}
            </mat-icon>
            <div>
              <span class="profile-preference-label">Modo oscuro</span>
              <span class="profile-preference-help">
                Preferencia sincronizada con tu cuenta
              </span>
            </div>
          </div>
          <mat-slide-toggle
            class="theme-switch"
            [disabled]="loadingTheme"
            [checked]="!!fb.AppUser?.darkMode"
            (change)="toggleTheme($event.checked)">
          </mat-slide-toggle>
        </div>
      </section>

      <section class="profile-section profile-section--actions">
        <h4 class="profile-section-title">
          <mat-icon class="profile-section-icon">settings_suggest</mat-icon>
          Seguridad
        </h4>
        <div class="profile-action-list">
          <button
            mat-flat-button
            type="button"
            class="profile-action-btn"
            [disabled]="sendingReset || !fb.AppUser?.email"
            (click)="resetPassword(fb.AppUser?.email)">
            <mat-icon>lock_reset</mat-icon>
            <div class="profile-action-text">
              <span class="profile-action-title">Recuperar contraseña</span>
              <span class="profile-action-help">
                Enlace de restablecimiento al correo
              </span>
            </div>
          </button>

          <button
            mat-flat-button
            type="button"
            class="profile-action-btn profile-action-btn--danger"
            (click)="logout()">
            <mat-icon>logout</mat-icon>
            <div class="profile-action-text">
              <span class="profile-action-title">Cerrar sesión</span>
              <span class="profile-action-help">
                Volvés al inicio de bienvenida
              </span>
            </div>
          </button>
        </div>
      </section>
    </div>
  }
</div>
